"use client";

import React, { Suspense } from "react";
import cx from "classnames";
import { useTranslations } from "next-intl";

import useHeader from "./useHeader";

import Link from "@/components/Link";
import Icon from "@ide/shared/components/Icon";

import CtaInstantConsultation from "@/components/CtaInstantConsultation";
import Menu from "@/components/Menu";
import HamburgerIcon from "@/components/HamburgerIcon";
import ExtendNav from "@/components/ExtendNav";
import PropertySearchModal from "@/components/PropertySearchModal";

import useModalStore from "@/stores/modal";
import useUxStore from "@/stores/ux";
import UserProfileLink from "@/components/UserProfileLink";

const Header = ({
  showInstantConsultation = true,
  showSearch = false,
  showSearchBar = false,
  barClassName = "",
  darkMode = false,
  wide = false,
  sticky = true,
  user,
}) => {
  const {
    closeSearchModal,
    isMenuOpen,
    isSearchOpen,
    openSearchModal,
    setIsMenuOpen,
    toggleMobileNav,
  } = useHeader();

  return (
    <>
      <div className="absolute left-0 right-0 h-12 bg-neutral-900"></div>

      <header
        className={cx(
          "w-full h-12 saturate-[1.8] backdrop-blur-md z-999 transition-colors",
          barClassName,
          {
            "bg-neutral-900/80": !isMenuOpen,
            "bg-neutral-900": isMenuOpen,
            "sticky top-0": sticky,
          },
        )}
        style={{ zIndex: 99 }}
      >
        <div className="h-12 px-4 relative z-50">
          <div
            className={cx("h-full mx-auto flex justify-between items-center", {
              "max-w-root": !wide,
              "max-w-root-wide": wide,
            })}
          >
            <div className="relative z-50 flex flex-1">
              <Link href="/" className="flex h-8 aspect-1315/281 shrink" prefetch={false}>
                <img
                  src="/assets/images/logo-white.svg"
                  alt="Inside Dubai Estate logo"
                  className="h-full"
                  width={1315}
                  height={281}
                />
              </Link>
            </div>

            <div className="flex flex-1 gap-1 md:gap-2 items-center justify-end">
              {showInstantConsultation && <CtaInstantConsultation />}

              {showSearch && (
                <Icon
                  icon="fa-solid fa-magnifying-glass"
                  className="relative z-50 w-4 cursor-pointer p-2 text-white"
                  onClick={isSearchOpen ? closeSearchModal : openSearchModal}
                />
              )}

              <div className="relative w-9 h-9 z-50">
                <HamburgerIcon onClick={toggleMobileNav} active={isMenuOpen} />
              </div>

              <div className="text-white">
                <UserProfileLink user={user} />
              </div>
            </div>
          </div>
        </div>

        <ExtendNav isOpen={isMenuOpen} duration={500} contentContainerClass="pt-12!">
          <Menu onLinkClick={toggleMobileNav} isOpen={isMenuOpen} />
        </ExtendNav>

        {showSearch && (
          <PropertySearchModal
            show={isSearchOpen}
            onClose={closeSearchModal}
            // onReset={() => {
            //   closeSearchModal();
            //   resetForm();
            // }}
            // onSubmit={() => {
            //   closeSearchModal();
            //   handleSubmit();
            // }}
          />
        )}
      </header>
    </>
  );
};

export default Header;
